/* eslint-disable */
import MobileNav from '../components/MobileNav'

export default {
  init() {
    // JavaScript to be fired on all pages

    $(document).on('facetwp-loaded', function () {
      var protocol = $(location).attr('protocol');
      var hostname = $(location).attr('hostname');
      var href = $(location).attr('href');
      var url = href.replace(protocol, "");
      url = url.replace(hostname, "");
      url = url.replace("//:3000", "");
      url = url.replace("//", "");
      url = "/programs" + url;
      $('#home-search--button').attr('href', url);

      // If incoming, show incoming program hero image
      if (FWP.facets['program_country']) {

        if (FWP.facets['program_country'][0] == 'united-states') {
          $('.single-photo-incoming').not('.single-photo-incoming--show').addClass('single-photo-incoming--show');
        } else {
          $('.single-photo-incoming').removeClass('single-photo-incoming--show');
        }
      }
    });

    $('.program-slides').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      autoplay: true,
      autoplaySpeed: 5000,
      asNavFor: '.slick-thumbs',
    });

    $('.slick-thumbs').slick({
      slidesToShow: 3, // 3,
      slidesToScroll: 1,
      asNavFor: '.program-slides',
      dots: true,
      centerMode: true,
      focusOnSelect: true,
    });

    var catcher = $('#anchor-catch');
    var sticky = $('#anchor-menu');

    function isScrolledTo(elem) {
      if (elem.length) {
        var docViewTop = $(window).scrollTop(); //num of pixels hidden above current screen
        var elemTop = $(elem).offset().top; //num of pixels above the elem
        return ((elemTop <= docViewTop));
      }
    }

    $(window).scroll(function () {
      if (isScrolledTo(sticky)) {
        sticky.css('position', 'fixed');
        sticky.css('top', '15px');
      }

      if (catcher.length) {
        var stopHeight = catcher.offset().top + catcher.height();

        if (stopHeight > sticky.offset().top) {
          sticky.css('position', 'relative');
          sticky.css('top', '0');
        }
      }
    });

    $('#program-filters-form .fSelect').each((index, elem) => {
      $(elem).fSelect();
    });

    new MobileNav();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js